let mergeGroupsData;

export const setMergeGroupsData = (obj) => (mergeGroupsData = obj);

export const getMergeGroupsData = () => mergeGroupsData;